import { render, staticRenderFns } from "./SolicitacaoDeOrcamentoView.vue?vue&type=template&id=500a91e8&scoped=true"
import script from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoDeOrcamentoView.vue?vue&type=style&index=0&id=500a91e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a91e8",
  null
  
)

export default component.exports